import instance from './intercept'
import { ElMessage } from 'element-plus'
import { AxiosRequest, CustomResponse } from './types'
import { getToken } from '@/scripts/token'
import { useInfoStoreHook } from '@/stores/modules/login'
class Abstract {

  protected headers: object = {
    'content-type': 'application/json',
  }

  private apiAxios({
    baseURL,
    headers,
    method,
    url,
    data,
    params,
    responseType,
  }: AxiosRequest | any): Promise<CustomResponse | any> {
    return new Promise((resolve, reject) => {
      let Authorization: string = `Bearer ${getToken()}`
      let currHeaders: any
      if (headers && headers.Authorization === null) {
        currHeaders = {}
      } else if(headers){
        currHeaders = Object.assign(headers, { 'Authorization': Authorization, 'token' : getToken(), isTest: true },)
      }
      else {
        //currHeaders = headers ? Object.assign(this.headers, { 'Authorization': Authorization },) : { 'Authorization': Authorization }
        currHeaders = Object.assign(this.headers, { 'Authorization': Authorization, 'token' : getToken(), isTest: true },)
      }
      if (!getToken()) {
        delete currHeaders.Authorization
        delete currHeaders.token
      } 
      return instance({
        baseURL,
        headers: currHeaders,
        method,
        url,
        params,
        data,
        responseType
      })
        .then((res: any) => {
          const userStore: any = useInfoStoreHook()
          var data = res.data
          var code = data?.code
          if (!code) {
            resolve(res)
            return
          }
          switch (code) {
            case 0:
              resolve(data)
              break
            case '0':
              resolve(data)
              break
            case '1':
              resolve(data)
              break
            case 401:
              resolve(data)
              break
            case 1017:
              /*
              出现1017:获取用户id失败
              1.current:获取当前企业
              2.重新获取token
              */
              userStore.getMenuAndCurrentCompany()
              break
            case 606:
              reject(data)
              break
            default:
              data.message && ElMessage.error(data.message)
              reject(data)
              break
          }
        }).catch(err => {
          reject(err)
        })
    })
  }

  /**
   * GET类型的网络请求
   */
  protected get({ baseURL, headers, url, data, params, responseType }: AxiosRequest) {

    return this.apiAxios({
      baseURL,
      headers,
      method: 'GET',
      url,
      data,
      params,
      responseType
    })
  }

  /**
   * POST类型的网络请求
   */
  protected post({
    baseURL,
    headers,
    url,
    data,
    params,
    responseType,
  }: AxiosRequest) {

    return this.apiAxios({
      baseURL,
      headers,
      method: 'POST',
      url,
      data,
      params,
      responseType,
    })
  }

  /**
   * PUT类型的网络请求
   */
  protected put({ baseURL, headers, url, data, params, responseType }: AxiosRequest) {
    return this.apiAxios({
      baseURL,
      headers,
      method: 'PUT',
      url,
      data,
      params,
      responseType
    })
  }

  /**
   * DELETE类型的网络请求
   */
  protected delete({ baseURL, headers, url, data, params, responseType }: AxiosRequest) {
    return this.apiAxios({
      baseURL,
      headers,
      method: 'DELETE',
      url,
      data,
      params,
      responseType
    })
  }
}

export default Abstract
